package one.primehealth.analytics.permissions

import one.healthium.base.preferences.AppPreferences
import org.koin.core.component.KoinComponent
import org.koin.core.component.inject

actual object TrackingPermission : KoinComponent {

    private val appPreferences: AppPreferences by inject()

    actual suspend fun requestTrackingAuthorization(): Boolean {
        appPreferences.attRequested = true
        return true
    }
}